export const INIT_NEW_REPORT = 'INIT_NEW_REPORT';
export const TOGGLE_NON_COMPLIANT = 'TOGGLE_NON_COMPLIANT';
export const TOGGLE_COMPLIANT = 'TOGGLE_COMPLIANT';
export const TOGGLE_NA = 'TOGGLE_NA';
export const UPDATE_AUDIT_DETAILS = 'UPDATE_AUDIT_DETAILS';
export const RESET_REPORT_STATE = 'RESET_REPORT_STATE';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const ADD_IMAGE = 'ADD_IMAGE';
export const REMOVE_IMAGE = 'REMOVE_IMAGE';
export const RESET_IMAGE_STATE = 'RESET_IMAGE_STATE';
export const UPDATE_REMARKS = 'UPDATE_REMARKS';
export const UPDATE_UPLOAD_STATUS = 'UPDATE_UPLOAD_STATUS';
